import { EntityAddForm, EntityAddFormPage } from "../common/entity/EntityAddForm";
import { EntityCloneForm, EntityCloneFormPage } from "../common/entity/EntityCloneForm";
import { EntityCloneFormProps, EntityDetailViewProps, EntityEditFormProps } from "../common/entity/EntityInterfaces";
import { EntityEditForm, EntityEditFormPage } from "../common/entity/EntityEditForm";
import { EntityDetailPage, EntityDetailView } from "../common/entity/EntityDetailPage";
import { CustomImportsTable } from "./Table/CustomImportsTable";
import { EntityTablePage } from "../common/entity/EntityTablePage";
import { CustomImportForm } from "./CustomImportForm";
import { CustomImportsDetail } from "./CustomImportsDetail";

// Add
export const CustomImportAddForm = () => {
  return <EntityAddForm entityTypeId={"customImports"}>{(props) => <CustomImportForm {...props} />}</EntityAddForm>;
};

export const CustomImportAddFormPage = () => {
  return (
    <EntityAddFormPage>
      <CustomImportAddForm />
    </EntityAddFormPage>
  );
};

// Clone
export const CustomImportCloneForm = ({ id }: EntityCloneFormProps<"customImports">) => {
  return (
    <EntityCloneForm id={id} entityTypeId={"customImports"}>
      {(props) => <CustomImportForm {...props} />}
    </EntityCloneForm>
  );
};

export const CustomImportCloneFormPage = () => {
  return (
    <EntityCloneFormPage<"customImports"> isIntId={false}>
      {(id) => <CustomImportCloneForm id={id} />}
    </EntityCloneFormPage>
  );
};

// Edit
export const CustomImportEditForm = ({ id }: EntityEditFormProps<"customImports">) => {
  return (
    <EntityEditForm id={id} entityTypeId={"customImports"} filters={{}}>
      {(props) => <CustomImportForm {...props} />}
    </EntityEditForm>
  );
};

export const CustomImportEditFormPage = () => {
  return (
    <EntityEditFormPage<"customImports"> isIntId={false}>{(id) => <CustomImportEditForm id={id} />}</EntityEditFormPage>
  );
};

// Detail
export const CustomImportsDetailView = ({ id }: EntityDetailViewProps<"customImports">) => {
  return (
    <EntityDetailView id={id} entityTypeId={"customImports"} filters={{}}>
      {(props) => <CustomImportsDetail {...props} />}
    </EntityDetailView>
  );
};

export const CustomImportDetailsPage = () => {
  return (
    <EntityDetailPage<"customImports"> isIntId={false}>{(id) => <CustomImportsDetailView id={id} />}</EntityDetailPage>
  );
};

export const CustomImportsTablePage = () => {
  return (
    <EntityTablePage entityTypeId={"customImports"}>{(props) => <CustomImportsTable {...props} />}</EntityTablePage>
  );
};
